<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-cash</v-icon>
                <span class="title font-weight-light">Relatório de doador</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.mesInicial" label="Data de Nascimento Incial" :items="meses" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.mesFinal" label="Data de Nascimento Final" :items="meses" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="6" sm="6" md="2">
                        <v-switch v-model="filtro.exibirEndereco" label="Exibir Endereço" style="margin-top: -5px"/>
                    </v-col>
                    <v-col cols="6" sm="6" md="2">
                        <v-switch v-model="filtro.exportarExcel" label="Exportar para Excel" style="margin-top: -5px"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.contribuicaoId" label="Contribuição" :items="contribuicoes" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.formaDeDoacaoId" label="Forma de doação" :items="formaDoacoes" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.regiaoId" label="Região/Grupo" :items="regioes" item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="onSearchDoador" clearable
                            item-text="nome" item-value="id" label="Doador Indicador" dense outlined/>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { ContribuicaoEnumService } from '@/core/services/doacao';
import DoadorService from '../../../core/services/doacao/DoadorService';
import FormaPagamentoEnumService from '../../../core/services/financeiro/FormaPagamentoEnumService';
import { RegiaoService } from '@/core/services/doacao';
import JSONToCSVConverter from '../../../assets/js/custom'

export default {
    data: () => ({
        filtro: {
            mesInicial: 0,
            mesFinal: 0,
            exibirEndereco: false,
            exportarExcel: false,
            contribuicaoId: -1,
            formaDeDoacaoId: -1,
            doadorId: 0,
            regiaoId: null
        },
        doadores: [],
        isDoadorLoading: false,
        onSearchDoador: null,
        meses: [],
        contribuicoes: [],
        formaDoacoes: [],
        regioes: [],
        service: new DoadorService()
    }),
    watch: { 
        onSearchDoador(val){
            if(this.isDoadorLoading) return;
            if(!val) return;

            this.isDoadorLoading = true;
            this.service.AutoComplete(val)
            .then(
                res=>{
                    this.doadores = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isDoadorLoading = false))
        }
    },
    methods: {
        GerarRelatorio(){

            var filter = {
                mesInicial: this.filtro.mesInicial.toString(),
                mesFinal: this.filtro.mesFinal.toString(),
                exibirEndereco: this.filtro.exibirEndereco.toString(),
                exportarExcel: this.filtro.exportarExcel.toString(),
                contribuicaoId: this.filtro.contribuicaoId.toString(),
                formaDeDoacaoId: this.filtro.formaDeDoacaoId.toString(),
                doadorId: this.filtro.doadorId.toString()
            }

            if(this.filtro.exportarExcel){
                this.service.FiltroComplementar(0,-1,[],[],null,[], filter).then(
                    res=>{
                        JSONToCSVConverter(res.data.items, "Relatorio_Doador", true);
                    },
                    err=>{
                        this.$swal('Aviso', err.message, 'error');
                    }
                )
            }
            else{
                this.AbrirJanela('relatorioDoador');
            }
        },
        LimparFiltros(){
            this.filtro = {
                mesInicial: 0,
                mesFinal: 0,
                exibirEndereco: false,
                exportarExcel: false,
                contribuicaoId: -1,
                formaDeDoacaoId: -1,
                doadorId: 0,
                regiaoId: null
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota ,
                query:{
                    mesInicial: this.filtro.mesInicial,
                    mesFinal: this.filtro.mesFinal,
                    exibirEndereco: this.filtro.exibirEndereco,
                    exportarExcel: this.filtro.exportarExcel,
                    contribuicaoId: this.filtro.contribuicaoId,
                    formaDeDoacaoId: this.filtro.formaDeDoacaoId,
                    doadorId: this.filtro.doadorId,
                    regiaoId: this.filtro.regiaoId
                }
            });
            window.open(routeLink.href,'_blank');
        }, 
    },
    mounted(){
        
        this.meses.push(
            {
                key: 0,
                value: 'TODOS'
            },
            {
                key: 1,
                value: 'Janeiro'
            },
            {
                key: 2,
                value: 'Fevereiro'
            },
            {
                key: 3,
                value: 'Março'
            },
            {
                key: 4,
                value: 'Abril'
            },
            {
                key: 5,
                value: 'Maio'
            },
            {
                key: 6,
                value: 'Junho'
            },
            {
                key: 7,
                value: 'Julho'
            },
            {
                key: 8,
                value: 'Agosto'
            },
            {
                key: 9,
                value: 'Setembro'
            },
            {
                key: 10,
                value: 'Outubro'
            },
            {
                key: 11,
                value: 'Novembro'
            },
            {
                key: 12,
                value: 'Dezembro'
            },
        )

        const contribuicaoEnumService = new ContribuicaoEnumService();
        contribuicaoEnumService.Listar()
        .then(
            res => {
                this.contribuicoes = res.data;
                this.contribuicoes.unshift(
                    {
                        key: -1,
                        value: 'TODOS'
                    }
                )
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );

        const formaDoacaoEnumService = new FormaPagamentoEnumService();
        formaDoacaoEnumService.Listar()
        .then(
            res=>{
                this.formaDoacoes = res.data;
                this.formaDoacoes.unshift(
                    {
                        key: -1,
                        value: 'TODOS'
                    }
                )
            },
            err=>{
                this.$swal('Aviso', err.message, 'error');
            }
        )

        const regiaoService = new RegiaoService();
        regiaoService.ListarTudo()
            .then(
                res => {
                    this.regioes = res.data.items;
                    this.regioes.unshift({
                        id: null,
                        nome: '---NENHUM---'
                    })
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
    }
}

</script>